<script setup lang="ts">
import type { SelectScrollUpButtonProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { reactiveOmit } from '@vueuse/core';
import { ChevronUp } from 'lucide';
import { SelectScrollUpButton, useForwardProps } from 'reka-ui';
import SphIcon from '@/components/base/icon/';
import { cn } from '@/utils/shadcn/lib/utils.ts';

defineOptions({
    compatConfig: {
        MODE: 3,
    },
});

const props = defineProps<SelectScrollUpButtonProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
    <SelectScrollUpButton
        data-slot="select-scroll-up-button"
        v-bind="forwardedProps"
        :class="cn('absolute inset-x-0 top-0 z-20 flex cursor-default items-center justify-center bg-popover py-1', props.class)"
    >
        <slot>
            <SphIcon
                :icon="ChevronUp"
                size="xs"
            />
        </slot>
    </SelectScrollUpButton>
</template>
